import { render, staticRenderFns } from "./TileButton.vue?vue&type=template&id=5c46cb88&scoped=true"
import script from "./TileButton.vue?vue&type=script&lang=ts"
export * from "./TileButton.vue?vue&type=script&lang=ts"
import style0 from "./TileButton.vue?vue&type=style&index=0&id=5c46cb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46cb88",
  null
  
)

export default component.exports